
import { Platform, StyleSheet, Dimensions } from 'react-native';

export const MIN_WIDTH = 900;
let deviceWidth = Dimensions.get('window').width;

const MARGING = '8%';

const buttonMobile = deviceWidth <= MIN_WIDTH ? {
    display: 'flex',
    marginTop: 40,
    marginRight: 0,
    marginLeft: 0,
    height: 50,
    justifyContent: 'center',
    textAlign: 'center'
} : {};

const buttonTextMobile = deviceWidth <= MIN_WIDTH ? {
    fontSize: 14,
    marginLeft: 0,
    marginRight: 0,
    color: "#FFF"
} : {};

const containerButtonMobile = deviceWidth <= MIN_WIDTH ? {
    justifyContent: 'space-around',
    // flexDirection: 'column-reverse',
    marginLeft: 0,
    marginRight: 0,
} : {};

const button = {
    display: 'flex',
    marginTop: 65,
    marginBottom: 10,
    marginRight: '1%',
    marginLeft: '1%',
    backgroundColor: '#e2051c',
    borderRadius: 0,
    height: 54,
    ...buttonMobile
};

const appHeaderCol = {
    flexDirection: "row",
    justifyContent: "center",
    height: "100%",
    maxHeight: 78,
    alignItems: "center",
    alignSelf: "center",
    borderStyle: "solid",
    borderRightColor: "#d4d4d4",
    borderRightWidth: 1,
    paddingLeft:10,
    paddingRight:10
};

export default StyleSheet.create({
    appHeader: {
        height: 100,
        backgroundColor: "#FFF"
    },
    appFooter: {
        height: 100,
        backgroundColor: "#f1f6f9",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: MARGING,
        marginTop: "3%"

    },
    appFooterText: {
        color: "#0067a2",
        fontWeight: "600",
    },
    appHeaderCol_1: {
        ...appHeaderCol,
        minWidth: 178
    },
    appHeaderCol_2: {
        ...appHeaderCol,
        minWidth: 324
    },
    appHeaderCol_3: {
        ...appHeaderCol,
        minWidth: 120,
        borderRightWidth: 0
    },
    content: {
        flex: 1,
        marginTop: "2%",
        marginRight: "10%",
        marginBottom: "2%",
        marginLeft: "10%",
    },
    button: {
        ...button
    },
    subTitle: {
        marginTop: 10
    },
    buttonInvisible: {
        ...button,
        opacity: 0
    },
    buttonDisabled: {
        ...button,
        opacity: 0.5
    },
    buttonBack: {
        ...button,
        backgroundColor: "#086ba4"
    },
    buttonText: {
        marginTop: Platform.OS !== 'web' ? 11 : 0,
        marginLeft: 49,
        marginRight: 49,
        fontSize: 16,
        color: "#FFF",
        ...buttonTextMobile
    },
    appDescription: {
        marginTop: "35px",
        fontWeight: "500",
        fontSize: 18,
        textAlign: "center",
        textTransform: "uppercase",
        color: "#BEBBB7",
        letterSpacing: 2,
    },
    bottomLink: {
    },
    textHeader: {
        backgroundColor: "#e2f6ff",
        fontSize: 22,
        fontWeight: "600",
        color: "#4d4b50",
        paddingTop: 35,
        paddingBottom: 35,
        paddingLeft: MARGING,
    },
    accordionText: {
        fontSize: 22,
        fontWeight: "600",
        color: "#0067a2",
    },
    accordionContent: {
        fontSize: 18,
        marginTop: 50,
        marginBottom: 50,
        backgroundColor: "#FFF",
        paddingLeft: MARGING,
        paddingRight: MARGING,
    },
    normalText: {
        fontSize: 18
    },
    linkText: {
        fontSize: 18,
        color: "#0067a2",
        textDecorationLine: "underline",
        textDecorationStyle: "solid"
    },
    linkBold: {
        fontSize: 18,
        fontWeight: "700",
        color: "#0067a2"
    },
    linkBlock: {
        // display: "block",
        width: "100%",
        height: "100%"
    },
    accordionHeader: {
        backgroundColor: "#e2f6ff",
        paddingTop: 35,
        paddingBottom: 35,
        paddingLeft: MARGING,
        paddingRight: MARGING,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    containerText: {
        width: '100%'
    },
    container: {
        width: '100%',
        paddingLeft: MARGING,
        paddingRight: MARGING
    },
    containerButton: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        paddingLeft: MARGING,
        paddingRight: MARGING,
        ...containerButtonMobile
    },
    appContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    appCol_2: {
        width: '100%',
        maxWidth: 1000,
    }
});
